import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @fragment SaleItemPackageListFragment
 * @since 1.0.0
 */
export const SaleItemPackageListFragment = gql `
  fragment SaleItemPackageListFragment on SaleItemPackage {
    id
    sku
    title
    infos
    active
    price
    icon
    createdAt
    updatedAt

    groups {
      id
      title
    }

    translations {
      id
      title
      infos
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }
  }

  ${LanguageFragment}
`;
